import { Injectable, WritableSignal } from '@angular/core';
import { ExtendsFactory, State } from '@noda-lib/utils/managers';

import { CartViewFlags } from '../states/cart.view.flags';

@Injectable({ providedIn: 'root' })
export class CartViewService extends ExtendsFactory(
  State({
    flags: CartViewFlags,
  }),
) {
  public setItemState(isCartOpen: boolean): void {
    this.getStateSignal.set(isCartOpen);
  }

  private get getStateSignal(): WritableSignal<boolean> {
    return this.getState('flags', 'isCartOpen');
  }
}
